import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import I18n from '../i18n';

export default function Checkbox(props) {
  const {onChange, className, checked, disabled, label, value, name, ...rest} = props;

  return (
    <label className="checkbox-component">
      <input
        type="checkbox"
        className={classnames(className)}
        name={name}
        value={value}
        onChange={onChange}
        checked={checked}
        disabled={disabled}
        {...rest}
      />
      <span>{I18n.t(label)}</span>
    </label>
  );
}

Checkbox.defaultProps = {
  checked: false,
  disabled: false,
};

Checkbox.propTypes = {
  /** A callback to execute when the checkbox value changes.*/
  onChange: PropTypes.func,
  /** An optional className to add to the HTML element. */
  className: PropTypes.string,
  /** When true, checks the checkbox. */
  checked: PropTypes.bool,
  /** When true, disables the checkbox. */
  disabled: PropTypes.bool,
  /** Text descriction for the checkbox. */
  label: PropTypes.string,
  /** Sets or returns the value of the value attribute of a checkbox. */
  value: PropTypes.any,
  /** Sets or returns the value of the name attribute of a checkbox. */
  name: PropTypes.string,
};
